// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__SvVFT","imageUploader":"EGiftCard_imageUploader__2C0HX"};